module.exports = __webpack_public_path__ + "static/media/mockup-consulta-light.064d21d1.png";